import { useMemo } from 'react'
import { Card, Spinner, Alert } from 'react-bootstrap'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from './highcharts-init'
import { useAdminAnalyticsBreakdown } from 'api/hooks/use-admin-analytics'
import EmptyState from 'shared/empty-state'

const BreakdownPieChart = ({ title, subtitle, endpoint, params }) => {
  const { data, isLoading, isError } = useAdminAnalyticsBreakdown({
    endpoint,
    params
  })

  const chartOptions = useMemo(() => ({
    chart: { type: 'pie' },
    colors: ['#1E2E48', '#27AB83', '#E9C46A', '#38BEC9', '#606060', '#D6E4EA'],
    title: { text: '' },
    credits: { enabled: false },
    exporting: {
      enabled: true,
      filename: title,
      fallbackToExportServer: false,
      libURL: '',
      buttons: { contextButton: { enabled: false } }
    },
    tooltip: {
      pointFormat: '<b>{point.y}</b> ({point.percentage:.1f}%)'
    },
    plotOptions: {
      pie: {
        innerSize: '50%',
        dataLabels: {
          enabled: true,
          format: '{point.name}: {point.percentage:.1f}%'
        }
      }
    },
    series: [{
      name: title,
      colorByPoint: true,
      data: (data || []).map((d) => ({
        name: d.key || 'Unknown',
        y: d.value
      }))
    }]
  }), [data, title])

  return (
    <Card className="h-100">
      <Card.Header className="bg-white">
        <div className="fw-bold">{title}</div>
        {subtitle && <div className="text-muted" style={{ fontSize: '0.8rem' }}>{subtitle}</div>}
      </Card.Header>
      <Card.Body>
        {isLoading && <div className="text-center py-5"><Spinner /></div>}
        {isError && <Alert variant="danger">Failed to load data</Alert>}
        {!isLoading && !isError && data?.length > 0 && (
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        )}
        {!isLoading && !isError && data?.length === 0 && (
          <EmptyState />
        )}
      </Card.Body>
    </Card>
  )
}

export default BreakdownPieChart
